import {useTranslation} from "react-i18next";
import {useIonAlert, useIonLoading} from "@ionic/react";
import {useCallback} from "react";
import type {FileToShare} from "app/utils/types";
import {downloadUrlAsFile} from "app/utils/stdlib";

export const useShareAction = () => {
  const {t} = useTranslation();
  const [presentLoading, dismissLoading] = useIonLoading();
  const [presentAlert] = useIonAlert();

  const performShare = useCallback(
    async (shareData: ShareData) => {
      let canShare: boolean;
      try {
        canShare = navigator.canShare(shareData);
        console.log("Can share returned", canShare);
      } catch (e) {
        console.warn("Can share threw an exception", e);
        canShare = false;
      }
      if (!canShare) {
        await presentAlert({
          header: t("g.share.error.title", {defaultValue: "Грешка при споделяне"}),
          message: t("g.share.error.generic", {
            defaultValue: "Вашият браузър не поддържа този начин за споделяне на файлове. Моля опитайте другите опции"
          }),
          buttons: [t("g.ok")]
        });
        return;
      }
      try {
        await navigator.share(shareData);
      } catch (e) {
        console.warn("Share threw an exception", e);
        // if (
        //   e &&
        //   typeof e === "object" &&
        //   "message" in e &&
        //   typeof e.message === "string" &&
        //   e.message.indexOf("aborted") !== -1
        // ) {
        //   return;
        // }
        // await presentAlert({
        //   header: t("g.share.error.title", {defaultValue: "Грешка при споделяне"}),
        //   message: t("g.share.error.generic", {
        //     defaultValue: "Вашият браузър не поддържа този начин за споделяне на файлове. Моля опитайте другите опции"
        //   }),
        //   buttons: [t("g.ok")]
        // });
      }
    },
    [presentAlert, t]
  );

  return useCallback(
    async (file: FileToShare) => {
      let downloadedFile: File;
      try {
        await presentLoading({
          message: t("g.share.download.downloading", {defaultValue: "Изтегляне на файла, моля изчакайте..."})
        });
        downloadedFile = await downloadUrlAsFile(file.url, file.filename);
      } catch {
        await presentAlert({
          header: t("g.share.download.error.title", {defaultValue: "Грешка при изтегляне на файла"}),
          message: t("g.share.download.error.message", {
            defaultValue: "Възникна грешка при изтегляне на файла. Моля опитайте отново."
          }),
          buttons: [t("g.ok")]
        });
        return;
      } finally {
        await dismissLoading();
      }
      const shareData = {
        files: [downloadedFile],
        text: `Споделен файл от FSAcademy: ${file.humanName ?? file.filename}`,
        title: file.humanName ?? undefined
      } satisfies ShareData;
      await performShare(shareData);
    },
    [dismissLoading, performShare, presentAlert, presentLoading, t]
  );
};
